import { createStrapiClient } from '../create-strapi-client';

export const strapiApi = createStrapiClient({
    origin: 'strapi-proxy',
});

export type AnyStrapiClient = typeof strapiApi;
